//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '../../api/index';
export default {
  components: {
  },
  name: "frhomoloLogin",
  data() {
    return {
      form: {
        name: '',
        pass: ''
      }
    }
  },
  props: ['crfcode', 'collection', 'baseURL', 'getLogin', 'AgetCrf', 'AgetCollection', 'loginWords'],
  methods: {
    onSubmit () {
      if (this.form.name && this.form.pass) {
        let pasKey = JSON.stringify(this.keyEncrypt(this.form.pass, this.collection))
        let url = {
          _csrf: this.crfcode,
          username: this.form.name,
          password: pasKey,
          responseType: 'json'
        }
        this.form.pass = pasKey
        this.getLogin(url)
      } else {
        // const h = this.$createElement;
        // Message({
        //   message: h('p', null, [
        //     h('span', null, '请输入 '),
        //     h('b', { style: 'color: teal' }, '用户名'),
        //     h('span', null, '或 '),
        //     h('b', { style: 'color: teal' }, '密码'),
        //   ])
        // });
      }
    },
    keyEncrypt(data, coll) {
      const rsaEncrypt = new JSEncrypt();
      rsaEncrypt.setPublicKey(coll); // 加入公钥
      const passPhrase = this.generateEncryptPassword(32);
      const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(
        CryptoJS.enc.Hex
      );
      const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
        CryptoJS.enc.Hex
      );
      const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: 128 / 32,
        iterations: 1000
      });
      const aesEncrypted = CryptoJS.AES.encrypt(data, key, {
        iv: CryptoJS.enc.Hex.parse(iv)
      });
      const aesKey = passPhrase + ":::" + salt + ":::" + aesEncrypted.iv;
      const encryptedMessage = aesEncrypted.ciphertext.toString(
        CryptoJS.enc.Base64
      );
      const encryptedKey = rsaEncrypt.encrypt(aesKey);
      const encrypted = encryptedKey + ":::" + encryptedMessage;
      return encrypted;
    },
    generateEncryptPassword(length) {
      const encryptPassChars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz*&-%/!?*+=()";
      let randomstring = "";
      for (let i = 0; i < length; i++) {
        const rnum = Math.floor(Math.random() * encryptPassChars.length);
        randomstring += encryptPassChars.substring(rnum, rnum + 1);
      }
      return randomstring;
    },
    getCrf() {
      api.getCsrf(this.baseURL).then(json => {
        this.AgetCrf(json.data.result);
      })
    },
    getCollection() {
      api.getColle(this.baseURL).then(json => {
        this.AgetCollection(json.data.result);
      })
    },
    cancel() {
      this.form = {
        name: '',
        pass: ''
      }
    }
  },
  watch: {
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getCrf()
    this.getCollection()
  }
};
